
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { baseUrl } from 'src/environments/environment';


@Injectable()
export class AuthService {

    currentUser;
    sessionHeaders;
    constructor(
        private http: HttpClient,
        private router: Router
    ) {
        // this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    }
    

    login(params) {
        return this.http.post(`/api/v1/sessions`, params);
    }

    signUp(params) {
        return this.http.post(`/api/v1/users`, params);
    }
    forgetPassword(params) {
        return this.http.post(`/users/password`, params);
    }
    signOut(){
        return this.http.delete(`/api/v1/sessions`, {});

    }
    
    

    setCurrentUser(user){
        localStorage.setItem('currentUser', JSON.stringify(user));
    }

    logout() {
        localStorage.clear();
        this.router.navigate(['auth/login']);
    }

    getCurrentUser() {
        return JSON.parse(localStorage.getItem('currentUser'));
    }

    
}
